import React from "react";
import HeaderInner from "../../Components/HeaderInner";
import { useGlobalContext } from "../../context/GlobalContext";
import Carosle from "../../Components/Carosle";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

export default function BoatBooking() {
  const headerImages = useGlobalContext().headerImages;
  const location = useLocation();
  const service = location.state?.service;
  const headerName =
    service?.display_name || service?.service_name || "Boat Booking";
  const { t } = useTranslation();

  console.log("service", service);

  // console.log("headerImages in boat booking page", headerImages);
  return (
    <>
      <HeaderInner headerName={headerName} />
      <main className="bg-white back-white pad-top-0">
        <Carosle
          className={"dot-bar less-margin small-dots"}
          headerImages={headerImages}
          isFirst={true}
        />
        <div
          style={{ marginTop: "20px", marginLeft: "5px", marginRight: "5px" }}
        >
          {t("Guests can reach Voco Monaco Dubai via boat transfer")}
        </div>

        <div
          style={{ marginTop: "20px", marginLeft: "5px", marginRight: "5px" }}
        >
          <Button
            className="reg-btn big w-100 flex-div center"
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => window.open(service?.link, "_blank")}
          >
            {t("Book Now")}
          </Button>
          <Button
            className="reg-btn big w-100 flex-div"
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() =>
              window.open(
                "https://maps.app.goo.gl/iQeJowQAQsojvbLT9?g_st=awb",
                "_blank",
              )
            }
          >
            {t("Boat Jetty Location")} 1
          </Button>
          <Button
            className="reg-btn big w-100 flex-div"
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() =>
              window.open(
                "https://maps.app.goo.gl/99KGJ1THKbm3YUvb7?g_st=iw",
                "_blank",
              )
            }
          >
            {t("Boat Jetty Location")} 2
          </Button>
        </div>
      </main>
    </>
  );
}
